import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const FundingEnquiryQuestionnaireRecord = Record({
  questionnaireId: '',
  sessionId: '',
  submissionId: '',
});

export default class FundingEnquiryQuestionnaire extends FundingEnquiryQuestionnaireRecord {
  static deserialize(jsonObject = {}) {
    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, {}), {});

    return new FundingEnquiryQuestionnaire(hydrated);
  }
}
